export default {
  title: "Estatus"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , canales: {
      label: "Canales"
      , th: "Canales"
    }
    , substatus: {
      label: "Sub Estatus"
      , th: "Sub Estatus"
    }
    , agregador: { label: "Permitir Agregador" }
    , merchandising: { label: "Permitir Merchandising" }
    , exclusiones: { label: "Permitir Exclusiones" }
    , showinapp: { label: "Mostrar en APP" }
  }
  , errors: {
    BD5000: { text: "Ocurrió un error en el catálogo de Estatus" }
    , WS5000: { text: "Ocurrió un error en el catálogo de Estatus" }
    , JS5000: { text: "Ocurrió un error en el catálogo de Estatus" }
    , CR5000: { text: "Ocurrió un error en el catálogo de Estatus" }
    , UK_Status: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/status.js